import { AnsweredQuestionWithId } from "../model";

import { getAnswerToQuestionWithId } from "../questionnaires/getAnswerToQuestionWithId";

import { PepRiskAssessmentQuestionsOptions } from "./models";

export const calculatePepRiskAssessmentScore = (questions: AnsweredQuestionWithId[]) => {
    return (Object.keys(PepRiskAssessmentQuestionsOptions) as (keyof typeof PepRiskAssessmentQuestionsOptions)[]).reduce((pepScore, key) => {
        const answer = getAnswerToQuestionWithId(questions, key);
        const options = PepRiskAssessmentQuestionsOptions[key] as { text: string; value: string; pepScore: number }[];
        const selectedAnswer = options.find(o => o.value === answer);
        return pepScore + ((selectedAnswer && selectedAnswer.pepScore) || 0);
    }, 0);
};
